import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

// 使用 import 配合 webpackChunkName 注释进行动态懒加载
const Home = () => import(/* webpackChunkName: "home" */ '@/pages/home/Index.vue');
const Detail = () => import(/* webpackChunkName: "detail" */ '@/pages/home/Detail.vue');
const Board = () => import(/* webpackChunkName: "board" */ '@/pages/home/Board.vue');
const Dataset = () => import(/* webpackChunkName: "dataset" */ '@/pages/home/Dataset.vue');
const Contributor = () =>
  import(/* webpackChunkName: "contributor" */ '@/pages/home/Contributor.vue');
const Challenge = () => import(/* webpackChunkName: "challenge" */ '@/pages/home/Challenge.vue');
const Zhuque = () => import(/* webpackChunkName: "zhuque" */ '@/pages/home/Zhuque.vue');
const Certificate = () =>
  import(/* webpackChunkName: "certificate" */ '@/pages/home/Certificate.vue');

const routes = [
  { path: '', name: 'Home', component: Home },
  { path: '/home', name: 'Home', component: Home },
  { path: '/detail', name: 'Detail', component: Detail },
  { path: '/board', name: 'Board', component: Board },
  { path: '/dataset', name: 'Dataset', component: Dataset },
  { path: '/contributor', name: 'Contributor', component: Contributor },
  { path: '/challenge', name: 'Challenge', component: Challenge },
  { path: '/certificate/:id', name: 'Certificate', component: Certificate },
  { path: '/zhuque', name: 'Zhuque', component: Zhuque },
];

// 使用 history 模式保持 spa url 的美观性
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
